import React, { useState, useEffect } from 'react';
import {
  Container,
  Menu,
  Content,
  MenuItem,
  Row,
  InfoText,
  InfoIcon,
} from '../MessageAnalytics/MessageAnalytics.styled';
import AllChannelsABversion from './Components/AllChannelsABversion';
import EmailABversion from './Components/EmailABversion';
import TextABversion from './Components/TextABversion';
import { CircularProgress } from '@material-ui/core';
import { ALL_CHANNELS, EMAIL, TEXT, STATISTICS_TABS } from '../constants';
import { AllChannelsIcon, EmailIcon, TextIcon } from '../SVGs/Icons.js';

const MessageAnalyticsABversion = ({
  textEvents,
  emailEvents,
  message,
  startDate,
  isLoadingData,
  setClickActivityVisibility,
  setOpenActivityVisibility,
  setDeliveryActivityVisibility,
  smartResendEmailEvents,
  isSmartResendAvailable,
  setSmartResendAvailability,
}) => {
  const [currentTab, setCurrentTab] = useState(STATISTICS_TABS[0]);
  useEffect(() => {
    setSmartResendAvailability(!!(message && smartResendEmailEvents));
  }, [message, smartResendEmailEvents]);

  const isLoading =
    isLoadingData || !(textEvents?.versionB && emailEvents?.versionB);
  const handleTabClick = tab => {
    setCurrentTab(tab);
  };

  const renderContent = currentTab => {
    switch (currentTab) {
      case ALL_CHANNELS:
        return (
          <AllChannelsABversion
            emailEvents={emailEvents}
            smartResendEmailEvents={smartResendEmailEvents}
            textEvents={textEvents}
            isSmartResendAvailable={isSmartResendAvailable}
            messageStatus={message?.status}
          />
        );
      case EMAIL:
        return (
          <EmailABversion
            emailEvents={emailEvents}
            smartResendEmailEvents={smartResendEmailEvents}
            isLoadingData={isLoading}
            message={message}
            startDate={startDate}
            setClickActivityVisibility={setClickActivityVisibility}
            setOpenActivityVisibility={setOpenActivityVisibility}
            setDeliveryActivityVisibility={setDeliveryActivityVisibility}
            isSmartResendAvailable={isSmartResendAvailable}
          />
        );
      case TEXT:
        return (
          <TextABversion
            isLoadingData={isLoading}
            message={message}
            startDate={startDate}
            textEvents={textEvents}
            setDeliveryActivityVisibility={setDeliveryActivityVisibility}
          />
        );
    }
  };

  const getIcon = title => {
    if (title === ALL_CHANNELS) {
      return (
        <AllChannelsIcon color={title === currentTab ? '#007ADE' : 'black'} />
      );
    } else if (title === EMAIL) {
      return <EmailIcon color={title === currentTab ? '#007ADE' : 'black'} />;
    } else if (title === TEXT) {
      return <TextIcon color={title === currentTab ? '#007ADE' : 'black'} />;
    }
  };

  return (
    <Container>
      <Row>
        <Menu>
          {STATISTICS_TABS.map(title => (
            <MenuItem
              onClick={() => handleTabClick(title)}
              key={title}
              className={title === currentTab && 'active'}
            >
              {getIcon(title)}
              {title}
            </MenuItem>
          ))}
        </Menu>
        <InfoText>
          <InfoIcon />
          <>Click a stat for more details</>
        </InfoText>
      </Row>
      {isLoading ? (
        <Content style={{ height: '85%' }}>
          <CircularProgress
            style={{ margin: 'auto', alignItems: 'center', color: '#007ADE' }}
          />
        </Content>
      ) : (
        <Content>{renderContent(currentTab)}</Content>
      )}
    </Container>
  );
};

export default MessageAnalyticsABversion;
